<div class="server-down-container">
    <h1>⚠️ Server is Down</h1>
    <p>Server is unreachable. Please try again later.</p>
    <p (click)="retryLogin()" class="retry-link">Click here to retry login</p>
  </div>
  